<div th:fragment="navigation__tertiary" class="navigation__tertiary">
    <div class="container">
        <div class="grid">
            <div class="">
                <ul class="tab">
                    <li>
                        <a (click)="taskClick()">{{'taskAdministration'|translate}}</a>
                    </li>
                    <li>
                        <a (click)="scheduledClick()">{{'scheduledTaskAdministration'|translate}}</a>
                    </li>
                    <li>
                        <a (click)="viewClick()">{{'viewRunHistory'|translate}}</a>
                    </li>
                </ul>

            </div>
            <div *ngIf="onLoad" style="padding: 25px;">
               {{'Welcome to the Scheduler Administrators home page'|translate}} !
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="task">
    <div class="content-wrapper">
        <table width="90%">
            <tbody>
                <tr>
                    <td width="1%">&nbsp;</td>
                    <td>
                        <h2>{{'schedulerTask'|translate}}</h2>
                        

                        <table class="mainTable" width="95%">
                            <tbody>
                                <tr>
                                    <td colspan="7"></td>
                                </tr>
                                <tr>
                                    <td colspan="7" style="border: 1px solid ; background-color: rgb(255, 224, 224);">
                                        {{'taskLine1'|translate}}. 
                                        <br>
                                        {{'taskLine2'|translate}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt" style="text-align:left">{{'taskName'|translate}}:</td>
                                    <td class="prompt" style="text-align:center">&nbsp;</td>
                                </tr>

                                <tr>
                                    <td>
                                        <select name="schedulableTask" style="width: 85%;"[(ngModel)]="dropDown1" #task1 (change)="taskSelect1(task1.value)">
                                            <option id="pleaseSelectATask" value="">-- {{'Please Select'|translate}}--</option>
                                            <option  *ngFor="let i of valu" [value]="i.id" [disabled]="i.disabled">{{i.name}} 
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input id="add" type="button" value="{{'add'|translate}}" (click)="addTask()">
                                    </td>
                                    

                                </tr>
                                    <span class="error" *ngIf="taskAddError">{{'Task Name Already Exists'|translate}}</span>

                                <tr>
                                    <td colspan="7"></td>
                                </tr>

                                <tr>
                                    <td colspan="7" style="border: 1px solid ; background-color: rgb(255, 224, 224);">
                                        {{'taskLine3'|translate}}.<br>
                                        {{'taskLine4'|translate}}.
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt" style="text-align:left">{{'taskId'|translate}}:</td>

                                    <td class="prompt" style="text-align:left">{{'taskName'|translate}}:</td>

                                    <td class="prompt" style="text-align:center">{{'parameters'|translate}}:</td>
                                    
                                   
                                </tr>

                             
                                <ng-container *ngFor="let all of allTask, let ind=index">
                                    <tr >
                                        
                                        <td style="width: 20%;" >{{all.taskId}}
                                        </td>
                                        <td style="width: 25%;">{{all.taskClassSimpleName}}
                                        </td>
                                <td class="buttonColumn" style="width: 5%;" *ngIf="!showArray[ind]" >
                                    <button class="button" (click)="showHideButton(all.taskId,ind)">{{'show'|translate}} >>></button>
                                    </td>
                                    <td class="buttonColumn" style="width: 5%;" *ngIf="showArray[ind]">
                                    <button class="button" (click)="showHideButton(all.taskId,ind)"><<< {{'hide'|translate}}</button>

                                    </td>
    
                                        <td class="buttonColumn" style="width: 20%;">
                                            <input type="submit" value="{{'Delete'|translate}}" (click)="deleteTask(all)">&nbsp;
                                            <input type="button" value="{{'history'|translate}}" (click)="historyNavigate(all.taskId,all.taskClassSimpleName)">&nbsp;
                                            <input type="button" value="{{'run'|translate}}" (click)="runTask(all.taskId,all.taskClassSimpleName)">
                                        </td>
                                        
                                        <td class="executionProgressColumn"  id="{{all.taskId}}" style="display:none; ">
                                            <div><img src="/assets/images/updateprogress.gif" alt="loading..."></div>
                                            </td>
                                    </tr>
    
    
                                    <tr  *ngIf="showArray[ind]">
                                        <td colspan="6">
                                            <table class="parametersTable">
                                                <tbody>
                                                    <tr>
                                                        <th style="border-left: 1px solid black;">{{'Name'|translate}}</th>
                                                        <th>{{'defaultValue'|translate}}</th>
                                                        <th>{{'currentValue'|translate}}</th>
                                                        <th>
                                                        </th>
                                                        <th style="border-right: 1px solid black;">
                                                        </th>
                                                    </tr>
                                                    <tr *ngFor="let i of showDetails;let j=index">
                                                        <td class="parameterNameColumn"
                                                            style="border-left: 1px solid black;">
                                                            {{i.parameterName}}
                                                        </td>
                                                        <td class="parameterValueColumn" style="width: 250px;">
                                                            {{i.defaultValue}}
                                                        </td>
                                                        <td class="parameterValueColumn"  name="fieldName" ngDefaultControl >
    
                                                            <input type="text"maxlength="1024"
                                                                size="80"  [(ngModel)]="parameterArray[j]" name="parameterArray">
                                                        </td>
                                                        <td class="buttonColumn">
                                                            <input type="submit" value="{{'Update'|translate}}"
                                                                (click)="updateform(i.taskParameterId,i.parameterName,i.value,i.taskId,j)">
                                                        </td>
                                                        <td class="buttonColumn" style="border-right: 1px solid black;">
                                                            <input type="submit" value="{{'Delete'|translate}}"
                                                                (click)="deleteForm(i.taskParameterId,i.parameterName,i.value,i.taskId);">
                                                        </td>
                                                    </tr>
                                                
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>
<ng-container *ngIf="scheduled">
    <div class="content-wrapper">
        <table width="90%">
            <tbody>
                <tr>
                    <td width="1%">&nbsp;</td>
                    <td>
                        <h2>{{'scheduledTaskAdministration'|translate}}</h2>
                        <br>
                       
                        <table class="mainTable" width="95%" cellpadding="3">
                            <tbody>
                                <tr>
                                    <td colspan="26"></td>
                                </tr>
                                <tr>
                                    <td colspan="10" style="border: 1px solid ; background-color: rgb(255, 224, 224);">
                                        {{'taskLine1'|translate}}
                                        <br>
                                        {{'taskLine2'|translate}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt" style="text-align:left">{{'taskName'|translate}}:</td>
                                    <td class="prompt" style="text-align:center">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <select name="dropDown" #task (change)="taskSelect(task.value)"[(ngModel)]="dropDown">
                                            <option id="pleaseSelectATask" value="">-- {{'Please Select'|translate}}--</option>
                                            <option *ngFor="let i of addTaskName" [disabled]="i.disabled"[value]="i.taskId">
                                                {{i.taskClassSimpleName}} ({{i.taskId}})</option>
                                            
                                        </select>
                                    </td>
                                    <td >
                                        <input id="add" type="button" value="{{'add'|translate}}" (click)="addScheduleTask()">
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="10"></td>
                                </tr>
                                <tr>
                                    <td colspan="10" style="border: 1px solid ; background-color: rgb(255, 224, 224);">
                                        
                                       {{'taskLine3'|translate}} .<br>
                                        {{'taskLine4'|translate}}.
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt" style="text-align:left">{{'scheduledTaskId'|translate}}:</td>
                                    <td class="prompt" style="text-align:left">{{'taskId'|translate}}:</td>
                                    <td class="prompt" style="text-align:left">{{'taskName'|translate}}:</td>
                                    <td class="prompt" style="text-align:center">{{'schedulerPattern'|translate}}:</td>
                                    <td class="prompt" style="text-align:left">{{'server'|translate}}:</td>
                                    <td class="prompt" style="text-align:left">{{'timeInThe'|translate}} (UK):</td>
                                    <td class="prompt" style="text-align:left">{{'timeInThe'|translate}} (EST/EDT):</td>
                                    <td class="prompt" style="text-align:left">{{'lastRun'|translate}} {{'Status'|translate}}:</td>
                                    <td class="prompt" style="text-align:center">&nbsp;</td>
                                </tr>
                                <tr bgcolor="#F9F9F9" *ngFor="let all of allScheduleTask">

                                    <td style="cursor:pointer;color:blue;" ><a (click)="scheduleUpdateView(all.id,all.taskId,all.taskName,all.pattern,all.serverName)">{{all.id}}</a></td>

                                    <td style="cursor:pointer;color:blue;"><a (click)="navigate(all.taskId,all.taskName)"
   
                                            title="View the task definition.">{{all.taskId}}</a></td>
                                    <td>{{all.taskName}}
                                    </td>
                                    <td style="text-align:center">{{all.pattern}}
                                    </td>
                                    <td>{{all.serverName}}
                                    </td>
                                    <td>{{all.create_ts}}
                                    </td>
                                    <td>{{all.modify_ts}}
                                    </td>
                                    <td>{{all.status}}
                                    </td>
                                   
                                    <td class="buttonColumn" style="text-align:center">
                                        <input type="button" value="{{'Delete'|translate}}"
                                            (click)="deleteSchedule(all)">&nbsp;
                                        <input type="button" value="{{'history'|translate}}" (click)="navigateHistory(all.id,all.taskId,all.taskName)">&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>
<ng-container *ngIf="scheduleAdd">
    <div class="content-wrapper">
        <table width="90%">
            <tbody><tr>
                <td width="1%">&nbsp;</td>
                <td>
                    <h2>{{'scheduledTaskAdministration'|translate}}</h2>
                    <br>
                    <span class="error" *ngIf="errMsg">{{'invalidSchedule'|translate}}</span>
                    <table class="mainTable" width="95%" cellpadding="3" >
                        <tbody><tr>
                            <td colspan="3"></td>
                        </tr> 
                        <tr>
                            <td colspan="3" style="border: 1px solid ; background-color: rgb(255, 224, 224);">
                               {{'Configure the scheduling parameter values for the task that you wish to schedule below'|translate}}.
                            </td>
                        </tr>
                                   
                            <tr >
                                <td class="prompt" style="text-align:left" width="15%">{{'taskId'|translate}}:</td>
                                <td style="text-align:left" >{{viewObj[0].taskId}}</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr >
                                <td class="prompt" style="text-align:left">{{'taskName'|translate}}:</td>
                                <td style="text-align:left" >{{viewObj[0].taskClassSimpleName}}</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr >
                                <td class="prompt" style="text-align:left">{{'schedulerPattern'|translate}}:</td>
                                <td style="text-align:left"><input type="text" size="30" maxlength="255" id="viewPattern" [(ngModel)]="pattern" ></td>
                                <td style="border: 1px solid ; background-color: rgb(255, 224, 224);text-align:left" width="50%">
                                    <p>{{'scheduleLine1'|translate}}:</p>
                                    <ol>
                                        <li><strong>Seconds sub-pattern.</strong> During which seconds of the minute
                                            should the task been launched? The values range is from 0 to 59.</li>
                                        <li><strong>{{'heading1'|translate}}.</strong>{{'scheduleLine2'|translate}}. </li>
                                        <li><strong>{{'heading2'|translate}}.</strong>{{'scheduleLine3'|translate}}. </li>
                                        <li><strong>{{'heading3'|translate}}.</strong>{{'scheduleLine4'|translate}}. </li>
                                        <li><strong>{{'heading4'|translate}}.</strong>{{'scheduleLine5'|translate}}. </li>
                                        <li><strong>{{'heading5'|translate}}.</strong> {{'scheduleLine6'|translate}}. </li>
                                    </ol>
                                    <p>{{'scheduleLine7'|translate}}.</p>
                                    <p>{{'scheduleLine8'|translate}}</p>
                                </td>								
                            </tr>
                            <tr >
                                <td class="prompt" style="text-align:left">{{'server'|translate}}:</td>
                                <td style="text-align:left"><input type="text" size="30" maxlength="255" id="viewServer" [(ngModel)]="server" ></td>
                                <td style="border: 1px solid ; background-color: rgb(255, 224, 224);text-align:left" width="50%">
                                    {{'scheduleLine9'|translate}}
                                </td>
                            </tr>
                            <tr>
                                <td class="prompt" style="text-align:left">{{'enabled'|translate}}<span style="color: red;">*</span>:</td>
                                <td style="text-align:left"><input type="checkbox" (click)="enabled()" [(ngModel)]="enable" name="enable"></td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td valign="top">
                                    <input type=button value="{{'Schedule'|translate}}" (click)="addSchedule()">
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                    </tbody></table>
                </td>
            </tr>
        </tbody></table>
    </div>
</ng-container>
<ng-container *ngIf="scheduleUpdate">
    <div class="content-wrapper">
        <table width="90%">
            <tbody><tr>
                <td width="1%">&nbsp;</td>
                <td>
                    <h2>{{'scheduledTaskAdministration'|translate}}</h2>
                    <br>
                    <span class="error" *ngIf="errMsg">{{'invalidSchedule'|translate}}</span>
                    <table class="mainTable" width="95%" cellpadding="3" >
                        <tbody><tr>
                            <td colspan="3"></td>
                        </tr> 
                        <tr>
                            <td colspan="3" style="border: 1px solid ; background-color: rgb(255, 224, 224);">
                                {{'schedulerLine1'|translate}}.  
                            </td>
                        </tr>
                                    <tr *ngFor="let view of viewScheduleUpdate">
                                        <td class="prompt" style="text-align:left">{{'Schedule Task Id'|translate}}:</td>
                                        <td style="text-align:left" >{{view.id}}</td>
                                        <td>&nbsp;</td>
                                    </tr>
                            <tr *ngFor="let view of viewScheduleUpdate">
                                <td class="prompt" style="text-align:left" width="15%">{{'taskId'|translate}}:</td>
                                <td style="text-align:left" >{{view.taskId}}</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr *ngFor="let view of viewScheduleUpdate">
                                <td class="prompt" style="text-align:left">{{'taskName'|translate}}:</td>
                                <td style="text-align:left">{{view.taskName}}</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr *ngFor="let view of viewScheduleUpdate">
                                <td class="prompt" style="text-align:left">{{'schedulerPattern'|translate}}:</td>
                                <td style="text-align:left"><input type="text" value={{view.pattern}} size="30" maxlength="255" id="viewPattern" [(ngModel)]="updatePattern"></td>
                                <td style="border: 1px solid ; background-color: rgb(255, 224, 224);text-align:left" width="50%">
                                    <p>{{'scheduleLine1'|translate}}:</p>
                                    <ol>
                                        <li><strong>Seconds sub-pattern.</strong> During which seconds of the minute
                                            should the task been launched? The values range is from 0 to 59.</li>
                                        <li><strong>{{'heading1'|translate}}.</strong>{{'scheduleLine2'|translate}}. </li>
                                        <li><strong>{{'heading2'|translate}}.</strong>{{'scheduleLine3'|translate}}. </li>
                                        <li><strong>{{'heading3'|translate}}.</strong>{{'scheduleLine4'|translate}}. </li>
                                        <li><strong>{{'heading4'|translate}}.</strong>{{'scheduleLine5'|translate}}. </li>
                                        <li><strong>{{'heading5'|translate}}.</strong> {{'scheduleLine6'|translate}}. </li>
                                    </ol>
                                    <p>{{'scheduleLine7'|translate}}.</p>
                                    <p>{{'scheduleLine8'|translate}}</p>
                                </td>								
                            </tr>
                            <tr *ngFor="let view of viewScheduleUpdate">
                                <td class="prompt" style="text-align:left">{{'server'|translate}}</td>
                                <td style="text-align:left"><input type="text" value={{view.serverName}} size="30" maxlength="255" id="viewServer" [(ngModel)]="updateServer"></td>
                                <td style="border: 1px solid ; background-color: rgb(255, 224, 224);text-align:left" width="50%">
                                    {{'scheduleLine9'|translate}}
                                </td>
                            </tr>
                            <tr>
                                <td class="prompt" style="text-align:left">{{'enabled'|translate}}:</td>
                                <td style="text-align:left"><input type="checkbox" name="enabled" value="true" checked=""></td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td valign="top">
                                    <button type=button (click)="updateSchedule()">{{'updateSchedule'|translate}}</button>
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                    </tbody></table>
                </td>
            </tr>
        </tbody></table>
    </div>
</ng-container>
<ng-container *ngIf="view">
    <div class="content-wrapper">
 <form (submit)="viewRunSubmit()">
        <table width="90%">
            <tbody>
                <tr>
                    <td width="1%">&nbsp;</td>
                    <td>
                        <h2>	
                            {{'schedulerRunHistory'|translate}}</h2>
                        <br>


                        <table class="mainTable" width="95%" cellpadding="3" >
                            <tbody >
                                <tr>
                                    <td colspan="26"></td>
                                </tr>
                                <tr>
                                    <td colspan="26" style="border: 1px solid ; background-color: rgb(255, 224, 224);">
                                        {{'viewLine1'|translate}}
                                        <br>
                                        {{'viewLine2'|translate}}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="prompt">{{'scheduledTaskId'|translate}}:</td>
                                    <td class="prompt" >
                                        <input type="text" name="scheduledTaskId" [(ngModel)]="viewtaskScheduledId" size="8"
                                            maxlength="8" value="">
                                    </td>
                                    <td valign="middle" rowspan="5">
                                        <input id="add" type="button" value="{{'SEARCH'|translate}}" (click)="viewRunHistory()">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt">{{'jobId'|translate}}:</td>
                                    <td class="prompt">
                                        <input type="text" name="jobId" [(ngModel)]="viewtaskJobId" size="8" maxlength="8"
                                            value="">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt">{{'taskId'|translate}}:</td>
                                    <td class="prompt">
                                        <input type="text" [(ngModel)]="viewtaskId" name="taskId" size="8" maxlength="8">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt">{{'taskName'|translate}}:</td>
                                    <td class="prompt">
                                        <select name="taskName" [(ngModel)]="viewtaskName">
                                            <option value="">--{{'Please Select'|translate}}--</option>

                                            <option *ngFor="let taskname of taskNameData">{{taskname.name}}
                                            </option>

                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt">{{'Status'|translate}}:</td>
                                    <td class="prompt">
                                        <select name="status" [(ngModel)]="viewstatus">
                                            <option value=null>-- {{'Please Select'|translate}} --</option>
                                            <option *ngFor="let status of statusData">{{status.name}}</option>

                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt">{{'Date'|translate}}:</td>
                                    <td class="prompt">
                                        <input type="text" #dp1="bsDatepicker" bsDatepicker placement="right" [(ngModel)]="viewstartDate" size="10"
                                            maxlength="10" name="viewstartDate" value="" [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',customTodayClass: 'custom-today-class'}">
                                            &nbsp;to&nbsp;
                                            <input type="text" #dp1="bsDatepicker" bsDatepicker placement="right"  [(ngModel)]="viewendDate" size="10"
                                            maxlength="10" name="viewendDate" [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',customTodayClass: 'custom-today-class'}">
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="26"></td>
                                </tr>
                                <tr>
                                    <td colspan="26" style="border: 1px solid ; background-color: rgb(255, 224, 224);">
                                        {{'viewLine3'|translate}}<br>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="prompt">{{'eventId'|translate}}</td>
                                    <td class="prompt">{{'jobId'|translate}}</td>
                                    <td class="prompt">	{{'scheduledTaskId'|translate}}</td>
                                    <td class="prompt">{{'taskId'|translate}}</td>
                                    <td class="prompt">{{'taskName'|translate}}</td>
                                    <td class="prompt" style="padding-right: 50px; text-align: right;">{{'user'|translate}}</td>
                                    <td class="prompt">{{'Time in the UK'|translate}}</td>
                                    <td class="prompt">{{'Time in the EST/EDT'|translate}}</td>
                                    <td class="prompt">{{'Status'|translate}}</td>
                                    <td class="prompt">{{'server'|translate}}</td>
                                </tr>
                                <tr *ngIf="errorMsg"><div>{{'Nothing found'|translate}}</div></tr>
                                <tr *ngFor="let view of viewRun">
                                    <td style="cursor:pointer;color:blue;" (click)="viewBasedOnEventId(view.eventId,view.taskJobId,view.taskScheduledId,view.taskId,
                                    view.taskName,view.userName,view.timeInUK,view.timeInEdtEst,view.status,view.serverName,view.message,view.eventDate)">{{view.eventId}}</td>
                                    <td style="cursor:pointer;color:blue;" (click)="viewJobId(view.taskJobId)">{{view.taskJobId}}</td>
                                    <td style="cursor:pointer;color:blue;"><a (click)="navigateSchedule(view.taskScheduledId,view.taskId,view.taskName)">{{view.taskScheduledId}}</a></td>
                                    <td style="cursor:pointer;color:blue;"><a (click)="navigate(view.taskId,view.taskName)">{{view.taskId}}</a></td>
                                    <td>{{view.taskName}}</td>
                                    <td>{{view.userName}}</td>
                                    <td>{{view.timeInUK}}</td>
                                    <td>{{view.timeInEdtEst}}</td>
                                    <td>{{view.status}}</td>
                                    <td>{{view.serverName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </form>
    </div>
</ng-container>
<ng-container *ngIf="viewEvent">
    <div class="content-wrapper">
        <table width="90%">
            <tbody>
                <tr>
                    <td width="1%">&nbsp;</td>
                    <td>
                        <h2>{{'schedulerRunHistory'|translate}}</h2>
                        <br>
                        <table class="mainTable" width="95%" cellpadding="3">
                            <tbody>
                                <tr>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="border: 1px solid ; background-color: rgb(255, 224, 224);">
                                        {{'viewLine4'|translate}}
                                        <br>
                                    </td>
                                </tr>
                                
                                    <tr *ngFor="let data of dataEvent">
                                        <td class="prompt">{{'eventId'|translate}}:</td>
                                        <td >{{data.eventId}}</td>
                                    </tr>
                                    <tr *ngFor="let data of dataEvent">
                                        <td class="prompt" >{{'jobId'|translate}}:</td>
                                        <td style="cursor:pointer;color:blue;"><a (click)="viewJobId(data.taskJobId)">
                                        {{data.taskJobId}}</a></td>
                                    </tr>
                                
                                
                                <tr *ngFor="let data of dataEvent">
                                    <td class="prompt">{{'scheduledTaskId'|translate}}:</td>

                                    <td style="cursor:pointer;color:blue;"><a (click)="navigateSchedule(data.taskScheduledId,data.taskId,data.taskName)">{{data.taskScheduledId}}</a></td>

                                </tr>
                                <tr *ngFor="let data of dataEvent">
                                    <td class="prompt">{{'taskId'|translate}}:</td>
                                    <td style="cursor:pointer;color:blue;"><a (click)="navigate(data.taskId,data.taskName)">{{data.taskId}}</a>
                                    </td>
                                </tr>
                                <tr *ngFor="let data of dataEvent">
                                    <td class="prompt">{{'taskName'|translate}}:</td>
                                    <td>{{data.taskName}}</td>
                                </tr>
                                <tr *ngFor="let data of dataEvent">
                                    <td class="prompt">{{'user'|translate}}:</td>
                                    <td>{{data.userId}}</td>
                                </tr>
                                <tr *ngFor="let data of dataEvent">
                                    <td class="prompt">Time in the UK:</td>
                                    <td>{{data.timeInUK}}</td>
                                </tr>
                                <tr *ngFor="let data of dataEvent">
                                    <td class="prompt">{{'Time in the EST/EDT'|translate}}:</td>
                                    <td>{{data.timeInEdtEst}}</td>
                                </tr>
                                <tr *ngFor="let data of dataEvent">
                                    <td class="prompt">{{'Status'|translate}}:</td>
                                    <td>{{data.status}}</td>
                                </tr>
                                <tr *ngFor="let data of dataEvent">
                                    <td class="prompt">{{'server'|translate}}:</td>
                                    <td>{{data.serverName}}</td>
                                </tr>
                                <tr>
                                    <td class="prompt">{{'message'|translate}}:</td>
                                    <td>&nbsp;</td>
                                </tr>
                            
                                <tr *ngFor="let data of dataEvent">
                                    <td colspan="2"><textarea id="eventMessage" cols="200" rows="20" readonly="readonly"
                                            wrap="off">{{data.message}}</textarea></td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>



